/**
 * @param {string} token Bearer value must be `sessionId&organizationId` — health-sprint-admin
 *   middleware parses it and merges session/org into the body.
 */
export async function checkHealthSprintPlayedApi({ userId, token }) {
  /** Same value as DB `userid` varchar — backends vary on camelCase vs column name. */
  const validString = (v) => v != null && String(v).trim() !== '' && String(v).toLowerCase() !== 'null' && String(v).toLowerCase() !== 'undefined';
  
  // Don't proceed if userId or token are invalid/null
  if (!validString(userId) || !validString(token)) {
    return { status: null };
  }
  
  const userid = String(userId).trim();
  const t = String(token).trim();
  const [sessionIdFromToken, organizationIdFromToken] = t.includes('&') ? t.split('&') : [null, null];
  /**
   * Use DB truth only (no client storage): ask backend for the stage/report row
   * for this session/org and derive `status` from that payload.
   */
  const normalize = (data) => {
    const safe = (data != null && typeof data === 'object') ? data : {};
    const report = safe.report ?? safe.data?.report ?? null;
    const statusRaw =
      report?.status ??
      report?.stage_status ??
      report?.stageStatus ??
      safe.status ??
      safe.data?.status ??
      null;
    const reportIdRaw =
      report?.reportid ??
      report?.reportId ??
      safe.reportid ??
      safe.reportId ??
      safe.data?.reportid ??
      safe.data?.reportId ??
      null;
    const reportId =
      reportIdRaw != null && String(reportIdRaw).trim() !== '' ? String(reportIdRaw).trim() : null;
    return { ...safe, status: statusRaw, reportId };
  };

  // Use the dedicated "played" endpoint only (do not call /fetchReport).
  const resp2 = await fetch(`${process.env.REACT_APP_BACKEND_URL}/checkHealthSprintPlayed`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${t}`,
    },
    body: JSON.stringify({
      userId: userid,
      userid,
      sessionId: sessionIdFromToken,
      organizationId: organizationIdFromToken,
    }),
  });
  if (!resp2.ok) {
    // Best-effort: never hard-fail login/report-seed flows because a DB table is missing.
    const err = await resp2.json().catch(() => ({}));
    return normalize(err);
  }
  const data2 = await resp2.json().catch(() => ({}));
  return normalize(data2);
}

/**
 * Block re-entry / skip report seed when sprint is finished.
 * `stages.status`: `playing` → never block; `completed` → block.
 */
export function isHealthSprintAlreadyCompleted(data) {
  if (!data || typeof data !== 'object') return false;
  const raw = data.status;
  if (raw == null || String(raw).trim() === '') return false;
  const st = String(raw).trim().toLowerCase();
  if (st === 'completed') return true;
  // Explicitly allow `playing` (and anything else) to proceed.
  return false;
}
